const DisconnectButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <button className="btn btn-error btn-wide text-white" onClick={onClick}>
      Disconnect
    </button>
  );
};

export default DisconnectButton;
